---
en:
  overview_map:
    homepage: Homepage
    nearest: nearest power plants
    news: News
    nve_concession: NVE concession case
